/**
 * @generated SignedSource<<1d3c548f1be5dea0cd7f9ea016fc4147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesHero_iconicDesignSeriesPage$data = {
  readonly cmsTopModule: {
    readonly bannerImage: string | null;
    readonly description: string | null;
    readonly mainImage: string | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesHeroByline_iconicDesignSeriesPage">;
  readonly " $fragmentType": "DesignSeriesHero_iconicDesignSeriesPage";
};
export type DesignSeriesHero_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesHero_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesHero_iconicDesignSeriesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesHero_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignSeriesCmsTopModule",
      "kind": "LinkedField",
      "name": "cmsTopModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mainImage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerImage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignSeriesHeroByline_iconicDesignSeriesPage"
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};

(node as any).hash = "77f9d223fac18c308484f8073ae3298b";

export default node;
